import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./NavigationLinks.module.css";
import { getNavigationLabelDefaults } from "./navigationLabelDefaults";

const NavigationLinks: React.FC = () => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const labels = getNavigationLabelDefaults(currentLang);

  return (
    <div className={styles.links}>
      <Link to={`/${currentLang}/`} className={styles.link}>
        <img
          src="/assets/images/wide_logo.png"
          alt="autovid_wide_logo"
          width={150}
        />
      </Link>

      <Link to={`/${currentLang}/features`} className={styles.link}>
        {t("navigation.features")}
      </Link>

      <Link to={`/${currentLang}/sample-videos`} className={styles.link}>
        {t("navigation.sample_videos", {
          defaultValue: currentLang.toLowerCase().startsWith("ko")
            ? "예시 영상"
            : "Sample Videos",
        })}
      </Link>

      <Link to={`/${currentLang}/youtube-rankings`} className={styles.link}>
        {t("navigation.youtube_rankings", {
          defaultValue: currentLang.toLowerCase().startsWith("ko")
            ? "유튜브 랭킹"
            : "YouTube Rankings",
        })}
      </Link>

      <Link to={`/${currentLang}/blog`} className={styles.link}>
        {labels.blog}
      </Link>

      <Link to={`/${currentLang}/updates`} className={styles.link}>
        {labels.updates}
      </Link>

      <Link to={`/${currentLang}/pricing`} className={styles.link}>
        {t("navigation.pricing")}
      </Link>

      <Link to={`/${currentLang}/how-to-use`} className={styles.link}>
        {t("navigation.how_to_use")}
      </Link>

      <Link to={`/${currentLang}/faq`} className={styles.link}>
        {t("navigation.faq", {
          defaultValue: labels.faq,
        })}
      </Link>

      <Link to={`/${currentLang}/support`} className={styles.link}>
        {t("navigation.support", {
          defaultValue: labels.support,
        })}
      </Link>

      <Link to={`/${currentLang}/support/chatbot`} className={styles.link}>
        {t("navigation.support_chatbot", {
          defaultValue: labels.supportChatbot,
        })}
      </Link>
    </div>
  );
};

export default NavigationLinks;
